/**
 * Resets the local error boundary before asking the router to re-run its loader.
 * Keeping this ordering shared prevents a retry from leaving a caught boundary stuck.
 */
export function createProfileRetry(reset: () => void, invalidate: () => unknown): () => void {
  return () => {
    reset();
    void invalidate();
  };
}
